<template>
  <div class="border border-red-700 w-full min-h-[100px]">
    <TextBlob headingSize="s" blobSize="full">
      <template #heading> Extended </template>
      <template #text>
        <div class="flex flex-col w-full items-center gap-4">
          <!-- Click Tracking Analytics with Toggle -->
          <div class="w-full flex justify-center">
            <el-button
              type="success"
              @click="showClickTracking = !showClickTracking"
              class=""
            >
              <span v-if="!showClickTracking">V</span>
              Click Tracking Analytics
            </el-button>
            <div v-show="showClickTracking" class="mb-4">
              <ClickTrackingAnalytics :is-visible="showClickTracking" />
            </div>
          </div>

          <ExtendedReviews />
          <ExtendedReviewers />
          <ExtendedUsers />
        </div>
      </template>
    </TextBlob>
  </div>
</template>

<script setup>
import TextBlob from "@/components/TextBlob.vue";
import { ref } from "vue";
import ExtendedReviews from "./ExtendedReviews.vue";
import ExtendedReviewers from "./ExtendedReviewers.vue";
import ExtendedUsers from "./ExtendedUsers.vue";
import ClickTrackingAnalytics from "./analytics/ClickTrackingAnalytics.vue";

const showClickTracking = ref(false);
</script>

<style scoped></style>
